import { Actions, Context } from '@cinch-nx/data-search'
import { sendDigitalDataEvent } from '@cinch-nx/shared-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { useState } from 'react'

export const useSearchAlertsDrawer = (searchLayoutArea: string) => {
  const [showSearchAlertsDrawer, setShowSearchAlertsDrawer] = useState(false)

  const closeSearchAlertsDrawer = () => {
    setShowSearchAlertsDrawer(false)
  }

  const handleSearchAlertsDrawerClick = () => {
    setShowSearchAlertsDrawer(true)
    datadogRum.addAction(Actions.SEARCH_ALERTS_CTA_CLICKED, {
      service: Context.SEARCH_ALERTS_SERVICE,
      squad: Context.SQUAD,
    })

    sendDigitalDataEvent({
      event: {
        name: 'click',
        category:
          searchLayoutArea === 'basket'
            ? 'search-alerts-filters-basket'
            : 'search-alerts-cta-block',
        action: 'open drawer',
        label:
          searchLayoutArea === 'noresults'
            ? 'set up search alert - no results'
            : 'set up search alert',
      },
    })
  }

  return {
    handleSearchAlertsDrawerClick,
    showSearchAlertsDrawer,
    closeSearchAlertsDrawer,
  }
}
